import React from 'react';
import PropTypes from 'prop-types';

import {Paper, Stack, Typography, Box, Avatar} from 'views/components';
import {Person as PersonIcon} from 'views/icons';
import {Translate, useNavigate} from 'views/module';

const ClientTile = (props) => {
  const {client} = props;

  const navigate = useNavigate();

  const contacts = client.clientDetail.contacts || {};

  const email = contacts['Email']?.detail;
  const phone = contacts['Phone number']?.detail;

  return (
    <Paper sx={{p: 2, borderRadius: 4, minHeight: 140, width: '100%'}}>
      <Stack spacing={1}>
        <Box sx={{display: 'flex', alignItems: 'center', gap: 1}}>
          <PersonIcon sx={{width: 24, height: 24, color: '#b0b0b0'}} />
          <Typography variant="h6" fontWeight={700}>
            <Translate expression='schedule.eventDetail.UserSection.Client.Title' />
          </Typography>
        </Box>
        <Box sx={{display: 'flex', alignItems: 'center', gap: 2}}>
          <Avatar
            alt={client.clientDetail.clientName}
            src={client.clientDetail.profileImg}
            sx={{
              width: 60,
              height: 60,
            }}
          />
          <Stack>
            <Typography
              variant="body2"
              onClick={() => navigate(`/client/${client.clientDetail.clientRn}`)}
              sx={{
                'cursor': 'pointer',
                '&:hover': {
                },
              }}
            >
              {client.clientDetail.clientName}
            </Typography>
            <Typography variant="caption" color="text.secondary" fontSize="0.7rem">
              {email || <Translate expression='schedule.eventDetail.UserSection.NoEmail' />}
            </Typography>
            <Typography variant="caption" color="text.secondary" fontSize="0.7rem">
              {phone || <Translate expression='schedule.eventDetail.UserSection.NoPhone' />}
            </Typography>
          </Stack>
        </Box>
      </Stack>
    </Paper>
  );
};

ClientTile.propTypes = {
  client: PropTypes.object.isRequired,
};

export default ClientTile;
